import { render, staticRenderFns } from "./TextFieldUpperCase.vue?vue&type=template&id=0a534048"
import script from "./TextFieldUpperCase.vue?vue&type=script&lang=js"
export * from "./TextFieldUpperCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VTextField,
})
